import {
  Box,
  Grid,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { FC, useState, useEffect } from "react";
import { load, remove } from "../../constants/storage";
import { H3, H4, H5, Small, Tiny } from "../../components/Typography";
import { useAppDispatch } from "../../store/hooks";
import ProgressBar from "react-customizable-progressbar";
import { useNavigate, useLocation } from "react-router-dom";
import * as Models from "../../models";
import GoalDeleteModel from "../../components/GoalDeleteModel";
import GoalWithdrawalModel from "../../components/GoalWithdrawalModel";
import DashboardNavbar from "../../components/DashboardNavbar";
import { API_BASE_URL } from "../../Api/EndPoints";
import { toast } from "react-hot-toast";
import AddBankModel from "../../components/AddBankModel";
import {
  redeemMutualFund,
  otpGenerateForMutualFund,
  otpVerifyForMutualFund,
} from "../../redux/actions/PortfolioAction";
import {
  cancelMFGoalMetalGoals,
  cancelGoalMetalGoals,
  sellGoalMetalGoals,
} from "../../redux/actions/GoalAction";
import OTPModel from "../../components/OTPModel";
import aesEncrypt from "../../constants/aesEncrypt";
import AddIcon from "@mui/icons-material/Add";
import { addBankAccount, getBankDetails } from "../../redux/actions";

const GoalDetailsScreen: FC = () => {
  const [loading, setLoading] = useState(false);
  let routeData = useLocation();
  const { item } = routeData.state;
  const dispatch = useAppDispatch();
  const [requestID, setRequestID] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [visibleBank, setVisibleBank] = useState(false);
  const [selectedBank, setSelectedBank] = useState<any>("");
  const [finaldata, setFinalData] = useState<any>();
  const [bankData, setBankData] = useState([]);
  const [openAddressModal, setAddressOpenModal] = useState(false);

  const handleAddressOpenModal = () => {
    setAddressOpenModal(true);
  };

  const handleAddressCloseModal = () => {
    setAddressOpenModal(false);
  };
  useEffect(() => {
    checkToken();
  }, []);
  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getBankDetailsData();
    }
  };

  let navigate = useNavigate();
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const getBankDetailsData = async () => {
    setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    dispatch(getBankDetails(finalUser.id, token))
      .then(async (response: any) => {
        if (response?.status === 401) {
          setLoading(false);
          return;
        }
        setBankData(response);
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //Cancel Goal model
  const [deleteGoalModel, setDeleteGoalModel] = useState(false);

  const handleDeleteGoalOpenModal = () => {
    setDeleteGoalModel(true);
    setVisibleBank(false);
  };
  const handleDeleteGoalCloseModal = () => {
    setVisibleBank(false);
    setDeleteGoalModel(false);
  };
  const handleSaveDeleteGoalModel = async () => {
    handleDeleteGoalCloseModal();
    if (item?.productId == "gold" || item?.productId == "silver") {
      if (item?.accountStatus == "CANCELLED") {
        setVisibleBank(true);
        return;
      } else {
        await cancelGoalMetalGoalsAction(item.virtualAccountId);
      }

      return;
    }

    if (item?.accountStatus == "CANCELLED") {
      await redeemFull();
      return;
    }

    await cancelGoalMFGoalsAction(item.virtualAccountId);
  };

  //Withdrawal Goal model
  const [withdrawalGoalModel, setWithdrawalGoalModel] = useState(false);

  const handleWithdrawalGoalOpenModal = () => {
    setWithdrawalGoalModel(true);
  };
  const handleWithdrawalGoalCloseModal = async () => {
    if (item?.productId === "gold" || item?.productId === "silver") {
      //bank visible
      setVisibleBank(true);
      setWithdrawalGoalModel(false);
    } else {
      if (item?.redeemableUnits > 0) {
        setWithdrawalGoalModel(false);
        await redeemFull();
        setVisibleBank(false);
        return;
      }
      setVisibleBank(false);
      setLoading(false);
      toast.error(
        "You don't have units to process this request or try after 48hrs"
      );
    }
  };

  const handleSaveWithdrawalGoalModel = async () => {
    setWithdrawalGoalModel(false);
    setVisibleBank(false);
    navigate(-1);
  };

  const getImgUrl = (pic: string) => {
    pic = pic?.toString().slice(1);
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  //Metal Goal cancel
  const cancelGoalMetalGoalsAction = async (virtualAccountId: string) => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.CancelMetalGoalRequest = {
      userId: userDetails.id,
      virtualId: virtualAccountId,
    };
    setLoading(true);
    dispatch(cancelGoalMetalGoals(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCodeValue === 400) {
          toast.error(response.body.message);
          return;
        }
        handleWithdrawalGoalOpenModal();
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  //MF Goal cancel
  const cancelGoalMFGoalsAction = async (virtualAccountId: string) => {
    if (item.redeemableUnits <= 0) {
      toast.error(
        "You don't have units to process this request or try after 48hrs"
      );
      return;
    }
    setLoading(true);
    let token = await load("token");
    dispatch(cancelMFGoalMetalGoals(virtualAccountId, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          toast.error(response?.error?.message);
          return;
        }
        handleWithdrawalGoalOpenModal();
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  const redeemFull = async () => {
    await OTPMODALDISPLAYFULL();
  };

  const OTPMODALDISPLAYFULL = async () => {
    await FULLCRETAEOTP();
  };

  const FULLCRETAEOTP = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.OTPGENERATEForRedeemMutualFund = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      purpose: "fund_redeem",
      fund_name: item?.productName ?? "",
      no_of_units: "all",
    };
    await OTPAPICALL(req);
  };

  const OTPAPICALL = async (req: any) => {
    let token = load("token");
    setLoading(true);
    dispatch(otpGenerateForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        handleOpenModal();
        setRequestID(response?.request_id);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  const redeemFullAction = async () => {
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.RedeemMutualFundRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: item.productId,
      folio_number: item.folioNo,
      redeem_all: true,
    };
    await redeemMutualFundUnitsAction(req, token);
  };

  const redeemMutualFundUnitsAction = async (req: any, token: any) => {
    setLoading(true);
    dispatch(redeemMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response?.statusCode === 400) {
          return;
        } else {
          toast.success("Redeem request initiated successfully");
          navigate("/transaction", {
            state: {
              type: "mutualFund",
            },
          });
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  //verify OTP
  const handleSave = async (value: any) => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    setLoading(true);

    const req = {
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      request_id: requestID,
      otp: aesEncrypt(value),
    };

    dispatch(otpVerifyForMutualFund(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.message === "OTP Authenticated Successfuly") {
          handleCloseModal();
          return redeemFullAction();
        }
        toast.error(response.message);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const handleAddressSave = (value: any) => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    const data = {
      mobileNo: finalUser.mobile,
      fullName: value.fullname,
      accountNumber: value.accountNo,
      ifscCode: value.ifscCode,
      consent: "true",
      bankName: "",
      userId: finalUser.id,
    };
    let token: any = load("token");
    dispatch(addBankAccount(data, token))
      .then(async (response: any) => {
        setLoading(false);
        if (response?.code === 0) {
          toast.success("Bank account added sucessfully");
          handleAddressCloseModal();
          getBankDetailsData();
        }
        if (response?.code === 2011) {
          toast.error(response.error);
          return;
        }
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const onProceed = () => {
    if (finaldata === undefined) {
      toast.error("Please select your bank.");
    } else {
      setLoading(true);
      let token: any = load("token");
      let userDetail: any = load("userData");
      let finalUser = JSON.parse(userDetail);

      const req: Models.SellMetalGoalRequest = {
        userId: finalUser.id,
        virtualId: item?.virtualAccountId,
        bankAccountNumber: finaldata?.accountNumber,
        bankIfscCode: finaldata?.ifscCode,
      };

      dispatch(sellGoalMetalGoals(req, `${token}`))
        .then(async (response: any) => {
          setLoading(false);
          if (response.statusCodeValue === 400) {
            alert(response.body.message);
            return;
          }
          if (response?.statusCode) {
            toast.success(response?.message);
            navigate("/goalDashboard");
            return;
          }
        })
        .catch((error: any) => {
          toast.error(error);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <GoalDeleteModel
        open={deleteGoalModel}
        handleClose={handleDeleteGoalCloseModal}
        handleSave={handleSaveDeleteGoalModel}
        data={item}
      />

      <AddBankModel
        open={openAddressModal}
        handleClose={handleAddressCloseModal}
        handleSave={handleAddressSave}
      />
      <GoalWithdrawalModel
        open={withdrawalGoalModel}
        handleClose={handleWithdrawalGoalCloseModal}
        handleSave={handleSaveWithdrawalGoalModel}
        data={item}
      />
      <OTPModel
        open={openModal}
        handleClose={handleCloseModal}
        handleSave={handleSave}
      />
      <DashboardNavbar />

      {loading ? (
        <Grid
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 1.5,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 1.5,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            height: "100vh",
          }}
        >
          {/* <GoalTopBanner /> */}
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              mb: 1,
              mt: 2,
            }}
          >
            Goal Detail
          </H3>
          <Box
            sx={{
              width: {
                md: "97%",
                xs: "90%",
              },
              borderRadius: 2,
              pl: 2,
              pr: 2,
              background: "#fff",
              alignItems: "center",
              pt: {
                xs: 2,
              },
            }}
          >
            {/* 1st Card */}
            <Box
              sx={{
                display: "flex",
                justifyContent: {
                  md: "space-between",
                  xs: "center",
                },
                flexDirection: {
                  md: "row",
                  xs: "column",
                },
                alignItems: {
                  xs: "center",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  borderRadius: 2,
                  alignItems: "center",
                  alignSelf: "flex-start",
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 50,
                    minwidth: {
                      md: 50,
                      xs: 70,
                      sm: 70,
                    },
                    background: "#F6F6F6",
                    p: 1.5,
                    borderRadius: 2,
                  }}
                  src={
                    item?.accountName == "Trip Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/trip.svg"
                      : item?.accountName == "Wedding Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/wedding.svg"
                      : item?.accountName == "Education Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/education.svg"
                      : item?.accountName == "Vehicle Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/vehicle.svg"
                      : item?.accountName == "Home Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/home.svg"
                      : item?.accountName == "Retirement Goal"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/retirement.svg"
                      : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/customGoal.svg"
                  }
                  alt="saas-dasboard-footer"
                />
                <Box
                  sx={{
                    flexDirection: "column",
                    display: "flex",
                    ml: 2,
                  }}
                >
                  <Small
                    sx={{
                      textAlign: {
                        md: "left",
                        xs: "left",
                      },
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: 12,
                    }}
                    fontWeight={"500"}
                    color="#0C0C0C"
                  >
                    {item?.accountName}
                  </Small>

                  <Small
                    sx={{
                      mt: 0.4,
                      fontSize: 12,
                      textAlign: {
                        md: "left",
                        xs: "center",
                      },
                    }}
                    fontWeight={"700"}
                    color="#0C0C0C"
                  >
                    Goal Amount:
                    <Small
                      sx={{
                        mt: 0.4,
                        fontSize: 12,
                        textAlign: {
                          md: "left",
                          xs: "center",
                        },
                      }}
                      fontWeight={"700"}
                      color={process.env.REACT_APP_PRIMARY_COLOR}
                    >
                      {" "}
                      ₹
                      <Small
                        sx={{
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 12,
                        }}
                        fontWeight={"700"}
                        color={process.env.REACT_APP_PRIMARY_COLOR}
                      >
                        {`${item.accountBalance}`}
                      </Small>
                    </Small>
                  </Small>
                </Box>
              </Box>
              {/* right */}
              <Grid
                sx={{
                  background: "#ffff",
                  width: "16%",
                  borderRadius: 2,
                  mb: 2,
                  justifyContent: "space-between",
                  display: "flex",
                  flexDirection: "column",

                  ml: 2,
                }}
                // onClick={() => {}}
              >
                <Box
                  sx={{
                    height: "15%",
                    borderRadius: 2,
                  }}
                ></Box>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    display: "flex",
                    paddingTop: -10,
                  }}
                >
                  <ProgressBar
                    progress={item?.changeBy}
                    radius={40}
                    strokeWidth={5}
                    trackStrokeWidth={5}
                    strokeColor={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <H5
                      color={process.env.REACT_APP_PRIMARY_COLOR}
                      fontWeight={"650"}
                      sx={{
                        color: process.env.REACT_APP_PRIMARY_COLOR,
                        fontFamily: "'Poppins', sans-serif",
                        width: "100%",
                        textAlign: "center",
                        flexDirection: "column",
                        display: "flex",
                      }}
                    >
                      {item?.changeBy.toFixed(2)}%
                      <Tiny
                        color="#000"
                        fontWeight={"400"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          width: "100%",
                          textAlign: "center",
                          fontSize: 10,
                        }}
                      >
                        Completed
                      </Tiny>
                    </H5>
                  </div>
                </div>
              </Grid>
            </Box>

            <H3
              fontWeight={500}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                mb: 2,
              }}
            >
              Investment Details
            </H3>
            <Box
              sx={{
                display: "flex",
                pb: { xs: 1, sm: 1, md: 1 },
                pr: { xs: 1, sm: 1, md: 1 },
                borderRadius: 1,
              }}
            >
              {item.productId != "gold" && item.productId != "silver" ? (
                <Box
                  component="img"
                  src={
                    item?.logo
                      ? getImgUrl(item?.logo)
                      : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                  }
                  sx={sxStyleImage}
                />
              ) : (
                <Box
                  component="img"
                  src={
                    item.productId == "gold"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                      : item.productId == "silver"
                      ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                      : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                  }
                  sx={sxStyleImage}
                />
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginLeft: 1.5,
                }}
              >
                <H4 fontSize={14} fontWeight={500} color="#000000" sx={text}>
                  {item?.productName}
                </H4>
                <Small
                  sx={{
                    mt: 0.4,
                    fontSize: 12,
                    textAlign: {
                      md: "left",
                      xs: "center",
                    },
                  }}
                  fontWeight={"700"}
                  color="#0C0C0C"
                >
                  SIP Amount:
                  <Small
                    sx={{
                      mt: 0.4,
                      fontSize: 12,
                      textAlign: {
                        md: "left",
                        xs: "center",
                      },
                    }}
                    fontWeight={"700"}
                    color={process.env.REACT_APP_PRIMARY_COLOR}
                  >
                    {" "}
                    ₹
                    <Small
                      sx={{
                        mt: 0.4,
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 12,
                      }}
                      fontWeight={"700"}
                      color={process.env.REACT_APP_PRIMARY_COLOR}
                    >
                      {`${item.investedAmt}`}
                    </Small>
                  </Small>
                </Small>
              </Box>
            </Box>

            {/* Investmnet */}
            <Grid sx={sxStyleGrid2}>
              <Grid sx={sxStyleGrid3}>
                <H4
                  color={process.env.REACT_APP_PRIMARY_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  fontWeight={"500"}
                >
                  ₹{item.investedAmt ?? "0"}
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                  color={"#868686"}
                >
                  Invested Amt.
                </H4>
              </Grid>
              <Grid sx={sxStyleGrid4}>
                <H4
                  color={process.env.REACT_APP_PRIMARY_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  fontWeight={"500"}
                >
                  ₹{item?.currentAmt ?? "0"}
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                  color={"#868686"}
                >
                  Current Value
                </H4>
              </Grid>
              <Grid sx={sxStyleGrid5}>
                <H4
                  color={process.env.REACT_APP_PRIMARY_COLOR}
                  sx={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  fontWeight={"500"}
                >
                  {`${item.paidInstallment}/${item.remainingInstallment}`}
                </H4>
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "center",
                  }}
                  color={"#868686"}
                >
                  Instalments
                </H4>
              </Grid>
            </Grid>

            {visibleBank ? (
              <>
                <H3
                  sx={{
                    fontFamily: "'Poppins', sans-serif",

                    pt: 2,
                  }}
                >
                  Select Bank
                </H3>

                {bankData.length === 0 ? (
                  <>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "95%",
                      }}
                    >
                      <Button
                        disableElevation
                        disableRipple
                        size="medium"
                        sx={{
                          background: "transparent",
                          color: process.env.REACT_APP_PRIMARY_COLOR,
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mb: 1,
                          borderRadius: 2,
                        }}
                        onClick={handleAddressOpenModal}
                      >
                        <AddIcon
                          style={{
                            color: process.env.REACT_APP_PRIMARY_COLOR,
                          }}
                        />
                        Add Bank
                      </Button>
                    </Box>
                  </>
                ) : (
                  <RadioGroup
                    aria-label="address"
                    name="address"
                    value={selectedBank}
                    onChange={(event: any) => {
                      setSelectedBank(event.target.value);

                      setFinalData(bankData[event.target.value]);
                    }}
                  >
                    <FormControl>
                      {bankData.map((item: any, index: number) => (
                        <FormControlLabel
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "89%",

                            borderRadius: 2,
                            mt: 2,
                            p: 2,
                            pl: 0,
                            // justifyContent: "space-between",
                          }}
                          value={index}
                          control={<Radio />}
                          label={
                            <Small
                              sx={{
                                textAlign: "left",
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: 12,
                              }}
                              fontWeight={"500"}
                              color="#0C0C0C"
                            >
                              Account No. :- {item.accountNumber} <br></br>
                              IFSC Code :- {item.ifscCode}
                            </Small>
                          }
                        />
                      ))}
                    </FormControl>
                  </RadioGroup>
                )}
                <Grid textAlign="center">
                  <Button
                    variant="contained"
                    onClick={onProceed}
                    sx={{
                      background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                      color: "#fff",
                      width: {
                        md: "50%",
                        xs: "100%",
                      },
                      mb: 1,
                      mt: 2,
                      borderRadius: 2,
                      textTransform: "none",
                    }}
                  >
                    Proceed
                  </Button>
                </Grid>
              </>
            ) : item?.productId != "gold" &&
              item?.productId != "silver" &&
              item?.accountStatus == "CANCELLED" &&
              item?.redeemableUnits <= 0 ? null : (
              <Grid textAlign="center">
                <Button
                  variant="contained"
                  onClick={handleDeleteGoalOpenModal}
                  sx={[cancel, { textTransform: "none" }]}
                >
                  {item?.accountStatus == "CANCELLED"
                    ? item?.productId != "gold" &&
                      item?.productId != "silver" &&
                      item?.accountStatus == "CANCELLED" &&
                      item?.redeemableUnits <= 0
                      ? null
                      : "Withdraw"
                    : "Cancel Goal"}
                </Button>
              </Grid>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default GoalDetailsScreen;

const cancel = {
  background: "#FFF5D1",
  color: "#D74040",
  width: {
    md: "45%",
    xs: "100%",
  },
  mt: 3,
  mb: 5,
  borderRadius: 2,
};

const sxStyleGrid2 = {
  display: "flex",
  borderTop: 0.2,
  borderBottom: 1,
  borderColor: "#EEEEEE",
  marginTop: 2,
};
const sxStyleGrid3 = {
  width: "33.33%",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
  borderTopColor: "#EEEEEE",
  borderTopWidth: 0.2,
  mt: 0.5,
  mb: 0.5,
};
const sxStyleGrid4 = {
  width: "33.33%",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",

  borderLeftWidth: "1px", // set the left border width to 2 pixels
  borderLeftStyle: "solid", // set the left border style to solid
  borderLeftColor: "#EEEEEE", // set the left border color

  pt: 2,
  pb: 2,
};
const sxStyleGrid5 = {
  width: "33.33%",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
  borderColor: "#EEEEEE",
  borderLeft: 1,
  borderLeftColor: "#EEEEEE",
};

const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 50,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
  p: 1,
  background: "#F4F4F4",
  borderRadius: 2,
};
const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
};
